import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import CurrentClientProfileContext from './CurrentClientProfileContext';
import useClientProfileGql from '../../../../client-profile/src/components/profile/hooks/useClientProfileGql';

function CurrentClientWrapper({ children }) {
  const [currentClient, setCurrentClient] = React.useState({});
  const { useClientProfileNodeQuery } = useClientProfileGql();

  const { data, loading, refetch } = useClientProfileNodeQuery();


  useEffect(() => {
    if (!loading && data && data.profile) {
      setCurrentClient(data.profile);
    }
  }, [data, loading, setCurrentClient]);

  if (loading) return null; // TODO ADD LOADING SCREEN

  return (
    <div style={{ marginTop: 78 }} className="profile-pages-wrapper">
      <CurrentClientProfileContext.Provider value={{ currentClient, setCurrentClient }}>
        {children}
      </CurrentClientProfileContext.Provider>
    </div>
  );
}

CurrentClientWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default CurrentClientWrapper;
